import ReactGA from "react-ga4";

export const useGAEventTracking = (category: string = "") => {
    const eventTracking = (action: string = "", label: string = "") => {      
        ReactGA.event({category, action, label});
    }
    return eventTracking;
}

export default useGAEventTracking;